import React from "react";
import Navbar from "../../Pages/Navbar/EmployerNavbar";
import Footer from "../../Footer/Footer";
import { Container } from "react-bootstrap";
import "./PolicyPages.css";

function PrivacyPolicy() {
  return (
    <>
      <Navbar />
      <div className="policy-section py-5 mt-5">
        <Container style={{textAlign:'justify'}}>
          <h1 className="mb-4 text-center fw-bold">
            Privacy Policy –{" "}
            <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
              Gulfworker.net
            </a>
          </h1>

          {/* <p className="text-muted text-center">Effective Date: [Insert Date]</p> */}
          {/* <p className="text-muted text-center">Last Updated: [Insert Date]</p> */}

          <p>
            At{" "}
            <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
              Gulfworker.net
            </a>{" "}
            (“Website,” “Portal,” “We,” or “Us”), your privacy is important.
            This Privacy Policy explains how we collect, use, and protect your
            personal information when you access or use our services.
          </p>

          <div className="mt-4">
            <h4>1. Information We Collect</h4>
            <p>We may collect the following types of information:</p>
            <ul>
              <li>
                <strong>Jobseekers:</strong> Name, email, phone number, CV, and
                professional profile details.
              </li>
              <li>
                <strong>Employers and Manpower Agencies:</strong> Company name,
                contact details, job postings, and subscription details.
              </li>
              <li>
                <strong>Technical Data:</strong> IP address, browser type,
                device information, and usage logs.
              </li>
            </ul>

            <h4>2. How We Use Your Information</h4>
            <p>Your information is used to:</p>
            <ul>
              <li>
                Provide job portal services to Jobseekers, Employers, and
                Agencies.
              </li>
              <li>
                Improve the Website’s functionality, performance, and user
                experience.
              </li>
              <li>
                Send notifications, updates, or promotional offers (if you opt
                in).
              </li>
              <li>
                Facilitate communication between Jobseekers, Employers, and
                Manpower Agencies.
              </li>
            </ul>

            <h4>3. Data Sharing</h4>
            <p>We do not sell or trade your personal information. Data may only be shared with:</p>
            <ul>
              <li>
                Employers and Manpower Agencies when Jobseekers apply for jobs.
              </li>
              <li>Service providers who assist in operating the platform.</li>
              <li>
                Legal authorities if required by law to comply with regulations.
              </li>
            </ul>

            <h4>4. Public Display of Information</h4>
            <ul>
              <li>
                Contact details of Jobseekers, Employers, and Manpower Agencies
                may be visible to other users and visitors of the Website for
                recruitment purposes.
              </li>
              <li>You are responsible for the information you choose to share publicly.</li>
            </ul>

            <h4>5. Data Security</h4>
            <ul>
              <li>
                We implement reasonable technical and organizational measures to
                protect your data.
              </li>
              <li>
                No system is completely secure; we cannot guarantee absolute
                protection.
              </li>
            </ul>

            <h4>6. Cookies</h4>
            <ul>
              <li>
                We use cookies to enhance your browsing experience and website
                functionality.
              </li>
              <li>
                You may disable cookies in your browser, but some features may
                not work correctly.
              </li>
            </ul>

            <h4>7. Your Rights</h4>
            <p>As a user, you may:</p>
            <ul>
              <li>Access, correct, or update your personal information.</li>
              <li>Request deletion of your account and associated data.</li>
              <li>Opt out of promotional communications at any time.</li>
            </ul>

            <h4>8. Policy Updates</h4>
            <p>
              <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                Gulfworker.net
              </a>{" "}
              may update this Privacy Policy as needed. Changes become effective
              once published on the Website. Continued use of the Website
              constitutes acceptance of the updated Policy.
            </p>

            <h4>9. Contact Us</h4>
            <p>
              For privacy-related inquiries, please contact: <br />
              📧 Email:{" "}
              <a href="mailto:support@gulfworker.net">support@gulfworker.net</a>
            </p>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
